import React from 'react'
import styles from './Availability.module.scss'
import clsx from 'clsx'
import type { DepartmentAvailabilityStatus } from '../../Types/DepartmentAvailability'

interface AvailabilityIconProps {
  online?: boolean
  status?: DepartmentAvailabilityStatus
}

export const AvailabilityIcon = ({ online, status }: AvailabilityIconProps) => {
  const resolved: DepartmentAvailabilityStatus = status ?? (online ? 'Online' : 'Offline')

  return (
    <div
      className={clsx(
        styles.circleIcon,
        resolved === 'Online' && styles.online,
        resolved === 'Busy' && styles.busy
      )}
    ></div>
  )
}
